import { Link } from "react-router-dom";

const OrderCard = ({ order }) => {
	const removeAutonums = (s) => {
		const regex = /(-\s?\d+)+$/;
		return s.replace(regex, "");
	};
	return (
		<div className="border border-black">
			<div className="bg-gray-200 border-b border-black  p-2">
				<Link to={"/order/" + order.id} className="font-bold text-lg text-blue-600 hover:text-blue-700 underline">
					{removeAutonums(order.name)}
				</Link>
			</div>

			<div className="p-2">
				<p>
					<span className="font-bold">Quotation Date:</span> {new Date(order.date_order).toLocaleDateString()}
				</p>
				<p>
					<span className="font-bold">Items Requested:</span> {order.productCount}
				</p>
				<p>
					<span className="font-bold">Module:</span> {order.x_studio_selection_field_TadkK}
				</p>
				<div className="flex items-center gap-1">
					<p className="font-bold">Status:</p>
					{order.state && order.state === "draft" ? (
						<div className="bg-gray-200 p-1 rounded-lg">
							<p>Pending</p>
						</div>
					) : null}
					{order.state && order.state === "sale" ? (
						<div className="bg-green-200 p-1 rounded-lg">
							<p>Confirmed</p>
						</div>
					) : null}
					{order.state && order.state !== "draft" && order.state !== "sale" ? <p>{order.state === "cancel" ? "Cancelled" : "Unknown"}</p> : null}
				</div>
			</div>
		</div>
	);
};

export default OrderCard;
